export default __webpack_public_path__ + "static/media/estructura.84d86ab0.png";